module.exports = __webpack_public_path__ + "img/pdf.24ba3727.svg";